<template>
<div class="modal-card">
  
  <header class="modal-card-head">
    <p class="modal-card-title">DEVMODE SUPPORT ONLY!</p>
  </header>
  
  <section class="modal-card-body">
    <div class="content thumbs">
      <div v-for="img,i in images" class="thumb">{{i}}
        <a :href="img.url" target="_blank"><img :src="maybeProxy(img.preview)"/></a>
        <b-input v-model="img.dims[0]" @input.native="onImageChanged(i)" type="number"/>
        <b-input v-model="img.dims[1]" @input.native="onImageChanged(i)" type="number"/>
        <b-input v-model="img.caption" @input.native="onImageChanged(i)"/>
        <b-select v-model="img.tags[0]" @input="onImageChanged(i)">
          <option v-for="o in extraTags" :value="o">{{o}}</option>
        </b-select>
      </div>
    </div>
    <div class="content text">
      <b-input v-model="content.content" @input.native="onContentChanged"/>
      <a target="_blank" :href="DB_ROOT+'projects/'+$store.state.uid+'/'+projid+'/posts/'+pid">meta<b-icon icon="link"/></a>
      <a target="_blank" :href="DB_ROOT+'contents/'+$store.state.uid+'/'+projid+'/'+pid">content<b-icon icon="link"/></a>
    </div>
  </section>

  <footer class="modal-card-foot">
    <div class="level">
      <div class="level-left"> </div>
      <div class="level-right">
        <button class="button" @click="cancel">Cancel</button>
        <button class="button is-primary" @click="done" :disabled="!imagesChanged && !contentChanged">Done</button>
      </div>
    </div>
  </footer>
</div>
</template>

<script>
import Firebase from '../firebase.js'
var db = Firebase.database


export default {
  name: 'PostEditorPage',
  data: function() { return {
    DB_ROOT: Firebase.dbViewUrlRoot,
    extraTags: ['orient0', 'orient6', 'orient-bad', 'rotate90', 'rotate180', 'rotate270', 'ignore', 'face'],
    imagesChanged: [],
    contentChanged: false,
    contentref: undefined,
    content: {},
    hello: 1,
  }},
  props: {
    projid: { type: String, required: true },
    pid: { required: true },
  },
  computed: {
    images: function() { return this.content.images || [] }
  },
  methods: {
    maybeProxy: function(url) {
      // avoid auto-upgrade to https in chrome v81+
      if (url.startsWith('http://')) {
        url = 'https://images.weserv.nl?url=' + url.substring(7)
      }
      return url
    },
    onImageChanged: function(imgIndex) {
      console.log('imageChanged',imgIndex,this.images[imgIndex])
      this.imagesChanged += imgIndex
    },
    onContentChanged: function() {
      console.log('contentChanged')
      this.contentChanged = true
    },
    cancel: function() {
      this.$parent.close()
    },
    done: function() {
      if (this.contentref) {
        if (this.imagesChanged) { 
          console.log('updating imgs ', this.imagesChanged)
          var update = Object.assign({}, this.images)
          delete update['.key']
          delete update['.value']
          Object.keys(update).forEach( i => {
            delete update[i]['.key']
            update[i].dims[0] = parseInt(update[i].dims[0])
            update[i].dims[1] = parseInt(update[i].dims[1])
          })
          console.log('updating imgs ', update)
          this.contentref.child('images').update(update)
        }
        if (this.contentChanged) {
          this.contentref.update({content: this.content.content})
        }
      }
      this.$parent.close()
    },
  },
  beforeMount: function() {
    var path = "/contents/"+this.$store.state.uid+"/"+this.projid+"/"+this.pid
    this.contentref = db.ref(path)
    this.$bindAsObject("content", this.contentref)
  }
}
</script>

<style scoped>
.thumbs {
    display: flex;
    flex-flow: row wrap;
  align-items: stretch;
}
.thumb {
    max-width: 25vw;
    width: 10em;
    border: 1px solid grey;
    padding: 1ex;
    display: inline-block;
    vertical-align: middle;
    margin-right: 1ex;
    margin-bottom: 1ex;
    position: relative;
}
.thumb img {
    max-width: 100%;
    max-height: 75%;
    margin: auto;
}
.thumb .desc {
    white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/PostEditorPage.vue